// extracted by mini-css-extract-plugin
export default {"result":"FormPopUp_result__eveCV","message":"FormPopUp_message__tJsXC","button":"FormPopUp_button__mFBqL"};